/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Injectable } from '@angular/core';
import { LocoDetail } from '../model/loco-detail.model';
import { StaticDataStoreService } from './static-datastore.service';
import { Subject } from 'rxjs';
/**
 * @export
 * @class LmsTabsDragDropService
 */
@Injectable()
export class LmsTabsDragDropService {
    tabDragStarted: Boolean = false;

    private interactiveLocoTrains: Subject<any> = new Subject();

    private tabdata: string;
    private originname = 'loco';
    private endSubject: Subject<any> = new Subject();
    private overSubject: Subject<any> = new Subject();
    private planTrainLocos: Subject<any> = new Subject();

    /*** this over and end create to handle
     * all over and end operation
     * like on tab drop we can also do things
     * ****START*****
     **/
    // work on drag end event
    end$ = this.endSubject.asObservable();
    // work on drag over
    over$ = this.overSubject.asObservable();
    interactiveLocoTrains$ = this.interactiveLocoTrains.asObservable();

    /* ****END ****/

    // when train or loco select then enable disable train or plan button
    planTrainLocos$ = this.planTrainLocos.asObservable();

    popupType: Object = {
        'INBOUND-OUTBOUND': 'train',
        'OUTBOUND-INBOUND': 'train',
        'INBOUND-INBOUND': 'train',
        'OUTBOUND-OUTBOUND': 'train',
        'PLAN-LOCO': 'plan',

        'INBOUND-onTerminalList': 'terminal',
        'OUTBOUND-onTerminalList': 'terminal',

        'atServiceCentreList-INBOUND': 'train',
        'atServiceCentreList-OUTBOUND': 'train',

        'onPitList-INBOUND': 'train',
        'onPitList-OUTBOUND': 'train',

        'inReadyTrackList-INBOUND': 'train',
        'inReadyTrackList-OUTBOUND': 'train',

        'storedAtTerminalList-INBOUND': 'train',
        'storedAtTerminalList-OUTBOUND': 'train',

        'inShopList-INBOUND': 'train',
        'inShopList-OUTBOUND': 'train',

        'onTerminalList-OUTBOUND': 'train',
        'onTerminalList-INBOUND': 'train',

        'yardAndLocalList-OUTBOUND': 'train',
        'yardAndLocalList-INBOUND': 'train',

        'complete-train': 'completeTrain',
        'cancel-train': 'cancelTrain'

    };

    headerMessage: Object = {
        completeTrain: 'Complete Train',
        cancelTrain: 'Cancel Train',
        train: 'Plan Locomotive',
        terminal: 'Plan Locomotive',
        plan: 'Plan Locomotive',
        resequence: 'Resequence Locomotive'
    };

    /**
     * Creates an instance of LmsTabsDragDropService.
     *
     * @memberOf LmsTabsDragDropService
     */
    constructor(private staticDataStoreService: StaticDataStoreService) {
        const planTrainLocos = {
            trains: [],
            locos: []
        };
        this.planTrainLocos.next(planTrainLocos);
    }

    /**
     * @param {string} typename
     * @param {any} value
     *
     * @memberOf LmsTabsDragDropService
     */
    updateDropEndValue(typename: string, value) {
        if (typename === 'end') {
            this.endSubject.next(value);
        } else {
            this.overSubject.next(value);
        }
    }

    /**
     *
     * @memberOf LmsTabsDragDropService
     */
    updateInteractiveLocoTrains(loco?: LocoDetail, type?: boolean) {
        if (type) {
            this.interactiveLocoTrains.next(loco);
        } else {
            this.interactiveLocoTrains.next(Math.random());

        }
    }

    /**
     * @memberOf LmsTabsDragDropService
     */
    set origin(name: string) {
        this.originname = name;
    }

    /**
     * @readonly
     *
     * @memberOf LmsTabsDragDropService
     */
    get origin() {
        return this.originname;
    }

    /**
     * @memberOf LmsTabsDragDropService
     */
    openTabInNewWindow() {
        const newwindow = window.open(this.staticDataStoreService.getValue('BASE_HREF'));
        if (window.focus) {
            newwindow.focus();
        }
    }

    /**
     * @param {*} dragData
     *
     * @memberOf LmsTabsDragDropService
     */
    writeToLocalStorage(dragData: any) {
        this.setTabDragStarted(true);
        localStorage.setItem('localTab', JSON.stringify(JSON.parse(dragData)));
    }

    /**
     * @param {any} id
     *
     * @memberOf LmsTabsDragDropService
     */
    removeFromLocalStorage(id) {
        localStorage.removeItem(id);
    }

    /**
     * @param {any} tabDragStarted
     *
     * @memberOf LmsTabsDragDropService
     */
    setTabDragStarted(tabDragStarted) {
        this.tabDragStarted = tabDragStarted;
    }

}
